import React from 'react';

import { SVGPropsType } from 'src/types';

function NoRecordTable(props: SVGPropsType) {
    const { fill, stroke, onClick, style, className } = props;

    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M23.3332 3.3335H9.99984C8.1665 3.3335 6.6665 4.8335 6.6665 6.66683V33.3335C6.6665 35.1668 8.1665 36.6668 9.99984 36.6668H29.9998C31.8332 36.6668 33.3332 35.1668 33.3332 33.3335V13.3335H23.3332V3.3335Z"
                fill={stroke}
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.333 13.3335H33.333L23.333 3.3335V13.3335Z"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15 25H25"
                stroke={fill}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default NoRecordTable;
